export enum ClinicConfigKeys {
  /***
   *  Since v2 - Sept 22' - we use a one unified config string -
   *  to setup the entire app configuration vs the old arbitrary lists
   *  of settings
   **/
  UnifiedConfigString = "unifiedConfigString",
  Translations = "translations",
  UsesLLM = "usesLLM",
  UsesRag = "usesRag",
  RagApp = "ragApp", // rag app / dialogue id
  ShowDialogue = "showDialogue",
  ShowInsights = "showInsights",
  UseDialogueForInsights = "useDialogueForInsights",
  GenerateInsightsFromClient = "generateInsightsFromClient",
  GroundAssessment = "groundAssessment",
  GroundExplanation = "groundExplanation",
  CustomPrompts = "customPrompts",
  /**@deprecated  use the new @kahunmedical/common-configuration module  to read the settings*/
  Theme = "theme",
  /**@deprecated  use the new @kahunmedical/common-configuration module  to read the settings*/
  FeatureFlags = "featureFlags",
  /**@deprecated  use the new @kahunmedical/common-configuration module  to read the settings*/
  ExternFeatureIdsMapping = "externalIds",
  /**@deprecated  use the new @kahunmedical/common-configuration module  to read the settings*/
  General = "general",
  /**@deprecated  use the new @kahunmedical/common-configuration module  to read the settings*/
  SolverFeatureFlags = "solverFeatureFlags",
  /**@deprecated  use the new @kahunmedical/common-configuration module  to read the settings*/
  Backoffice = "backoffice",
}
